<div class="download-dialog">
  <h2>{{ 'NEW_OFFER.DIALOG.TITLE' | i18nextEager }}</h2>
  <div class="download-dialog__buttons">
    <button (click)="close()">{{ 'COMMONS.NO' | i18nextEager }}</button>
    <button (click)="download()">{{ 'NEW_OFFER.DIALOG.DOWNLOAD' | i18nextEager }}</button>
  </div>
</div>
